import { LoginPage } from './pages/LoginPage.js';
import { CashierPage } from './pages/CashierPage.js'; // Reconfirmado: importación nombrada
//import { OperatorPage } from './pages/OperatorPage.js';
//import { RegisterPage } from './pages/RegisterPage.js';
import { AdminPage } from './pages/AdminPage.js';
import { PayoutPage } from './pages/PayoutPage.js';
import { authService } from './services/authService.js';
import { Header } from './components/Header.js';
import { Footer } from './components/Footer.js';


// Objeto para manejar el enrutamiento simple del frontend
export const router = {
    routes: [
        { path: '/login', component: LoginPage, public: true },
        //{ path: '/RegisterPage', component: RegisterPage, public: true },
        { path: '/cashier', component: CashierPage, roles: ['cashier', 'admin'] },
        //{ path: '/OperatorPage', component: OperatorPage, roles: ['payout_agent', 'admin','cashier'] },
        { path: '/admin', component: AdminPage, roles: ['admin'] },
        { path: '/payout', component: PayoutPage, roles: ['payout_agent', 'admin','cashier'] },
        { path: '/', redirectTo: '/cashier', roles: ['cashier', 'admin', 'payout_agent'] }, // Redirección por defecto si está logueado
        { path: '/', redirectTo: '/login', public: true } // Redirección por defecto si no está logueado
    ],
    // Función para renderizar la página actual
    async render(path) {
        const appRoot = document.getElementById('app-root');
        appRoot.innerHTML = ''; // Limpiar contenido anterior

        let route = this.routes.find(r => r.path === path);

        // Manejo de redirecciones iniciales si la ruta no se encuentra directamente
        if (!route) {
            // Si la ruta no existe, intentar usar la ruta por defecto (la primera '/')
            route = this.routes.find(r => r.path === '/');
        }

        const isAuthenticated = authService.isAuthenticated();
        const currentUser = authService.getCurrentUser();

        // Lógica de protección de rutas
        if (!route.public && !isAuthenticated) {
            // Si la ruta es protegida y no está autenticado, redirigir al login
            window.history.pushState({}, '', '/login');
            this.render('/login');
            return;
        }

        if (route.public && isAuthenticated && route.path === '/login') {
            // Si está autenticado e intenta ir al login, redirigir a su página por defecto
            const defaultRouteForRole = this.routes.find(r => r.path === '/' && r.roles && authService.hasRole(r.roles));
            if (defaultRouteForRole) {
                window.history.pushState({}, '', defaultRouteForRole.redirectTo);
                this.render(defaultRouteForRole.redirectTo);
                return;
            }
        }

        if (isAuthenticated && route.roles && !authService.hasRole(route.roles)) {
            // Si está autenticado pero no tiene el rol, redirigir a una página de acceso denegado o a su dashboard
            console.warn(`Acceso denegado a ${path} para el rol ${currentUser.role}`);
            window.history.pushState({}, '', '/cashier'); // O a una página de error 403
            this.render('/cashier');
            return;
        }

        // Si la ruta es una redirección, actualizar la URL y renderizar la nueva ruta
        if (route && route.redirectTo && route.path === path) { // Solo redirigir si es la ruta que se intentó cargar
            window.history.pushState({}, '', route.redirectTo);
            this.render(route.redirectTo);
            return;
        }

        // Si la ruta no tiene un componente o no se encuentra después de todas las redirecciones
        if (!route || !route.component) {
            appRoot.innerHTML = '<h1>404 - Página no encontrada</h1>';
            return;
        }

        // Renderizar el componente
        appRoot.appendChild(route.component());

    },

    // Función para navegar programáticamente
    navigate(path) {
        window.history.pushState({}, '', path);
        this.render(path);
    },
};

// Manejar los cambios de URL del navegador (flechas atrás/adelante)
window.addEventListener('popstate', () => {
    router.render(window.location.pathname);
});
